module.exports = __webpack_public_path__ + "static/lunker_banner-00996e7341fe94619ccef94e4c4b11f3.png";